'use client'

import Link from "next/link"

export function Footer() {
  return (
    <footer className="relative border-t border-black/10 py-14 md:py-16">
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2 md:col-span-2">
            <Link href="/" className="inline-flex items-center gap-3 text-[#0A0A0A]">
              <span className="font-display text-xl font-semibold tracking-tight text-[#0A0A0A]">
                Ziannah
              </span>
              <span className="text-black/30">|</span>
              <span className="text-[11px] uppercase tracking-[0.18em] text-black/60">AI architectural rendering</span>
            </Link>
            <p className="mt-5 text-sm text-black/60 max-w-xs">
              Photoreal architectural renders from your SketchUp, Revit, or Rhino model. In your browser, under a minute.
            </p>
            <a
              href="mailto:hello@ziannah.com"
              className="mt-4 inline-block text-sm text-[#0A0A0A] hover:text-black/70 transition-colors"
            >
              hello@ziannah.com
            </a>

            {/* Social profiles — closes the sameAs verification loop for
                Google by giving it a visible site → profile link that
                matches the schema-declared social URLs. */}
            <div className="mt-5 flex items-center gap-3.5">
              <a
                href="https://www.instagram.com/ziannahhq/"
                target="_blank"
                rel="noopener noreferrer me"
                aria-label="Ziannah on Instagram"
                className="hover:opacity-80 transition-opacity"
              >
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="url(#ig-gradient)"
                  strokeWidth="1.85"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <defs>
                    <linearGradient id="ig-gradient" x1="0%" y1="100%" x2="100%" y2="0%">
                      <stop offset="0%" stopColor="#FEDA75" />
                      <stop offset="25%" stopColor="#FA7E1E" />
                      <stop offset="50%" stopColor="#D62976" />
                      <stop offset="75%" stopColor="#962FBF" />
                      <stop offset="100%" stopColor="#4F5BD5" />
                    </linearGradient>
                  </defs>
                  <rect x="2" y="2" width="20" height="20" rx="5" />
                  <circle cx="12" cy="12" r="4" />
                  <circle cx="17.5" cy="6.5" r="0.9" fill="url(#ig-gradient)" stroke="none" />
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/company/ziannahhq/"
                target="_blank"
                rel="noopener noreferrer me"
                aria-label="Ziannah on LinkedIn"
                className="text-[#0A66C2] hover:opacity-80 transition-opacity"
              >
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M20.45 20.45h-3.55v-5.57c0-1.33-.03-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.45v6.29zM5.34 7.43A2.06 2.06 0 1 1 5.34 3.3a2.06 2.06 0 0 1 0 4.13zM7.12 20.45H3.55V9h3.57v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.73V1.73C24 .77 23.2 0 22.22 0z" />
                </svg>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-[11px] uppercase tracking-[0.18em] text-black/60 mb-4">Product</h3>
            <ul className="space-y-2.5">
              <li><Link href="/#tools" className="text-sm text-black/75 hover:text-black transition-colors">Tools</Link></li>
              <li><Link href="/#capabilities" className="text-sm text-black/75 hover:text-black transition-colors">Capabilities</Link></li>
              <li><Link href="/#modes" className="text-sm text-black/75 hover:text-black transition-colors">Services</Link></li>
              <li><Link href="/pricing" className="text-sm text-black/75 hover:text-black transition-colors">Pricing</Link></li>
              <li><Link href="/#faq" className="text-sm text-black/75 hover:text-black transition-colors">FAQ</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-[11px] uppercase tracking-[0.18em] text-black/60 mb-4">Company</h3>
            <ul className="space-y-2.5">
              <li><Link href="/terms" className="text-sm text-black/75 hover:text-black transition-colors">Terms</Link></li>
              <li><Link href="/privacy" className="text-sm text-black/75 hover:text-black transition-colors">Privacy</Link></li>
              <li><Link href="/refund" className="text-sm text-black/75 hover:text-black transition-colors">Refund</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-black/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-black/60">© {new Date().getFullYear()} Ziannah. All rights reserved.</p>
          <p className="text-xs text-black/60">Built for architects and interior designers.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
